import { createUseStyles } from 'react-jss';
import { color, fontSize, spacing } from '@blink/components';

export const useBorrowStyle = createUseStyles({
    wrapper: {
        maxWidth: 960,
        paddingTop: spacing['07'],
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        color: color.content.primary,
    },
    left: {
        flex: 1.05,
        minWidth: 520,
        padding: `0 ${spacing['07']} ${spacing['07']} 0`,
        borderRight: `1px solid ${color.border.stateDisable}`,

        '& img + div': {
            fontWeight: 600,
        },
        '& .ant-input': {
            fontWeight: 600,
        },
        '& .assetsWrapper button > .root > div': {
            fontWeight: 600,
        },
    },
    right: {
        display: 'flex',
        minWidth: 440,
        flexDirection: 'column',
        gap: 12,
        flex: 1,
        padding: `0 0 ${spacing['07']} ${spacing['07']}`,
        borderRadius: 4,
        '& .assetsWrapper button > .root > div': {
            fontWeight: 600,
        },
    },
    btnWrapper: {
        display: 'flex',
        paddingTop: spacing['04'],
    },
    submitButton: {
        fontSize: fontSize.md,
        width: '100%',
        marginTop: '50px',
        '&:active': {
            border: 'none !important',
        },
    },
    button: {
        width: '100%',
        height: 'auto',
        border: 0,
        backgroundColor: color.background.primary,
        padding: '12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '50px',

        '&:hover': {
            backgroundColor: color.background.secondary,
        },

        '&:disabled': {
            backgroundColor: `${color.background.secondary}!important`,
            color: color.content.fourth,
            cursor: 'not-allowed',
        },
    },
});
